import Component from '@glimmer/component';
import { LinkTo } from '@ember/routing';

export default class RecentMatchPlayer extends Component {
  get videoUrl() {
    // Use the first round's embed URL if available
    if (this.args.match?.rounds?.length > 0) {
      return this.args.match.rounds[0].embedUrl;
    }
    return null;
  }

  <template>
    <div class='widget-item'>
      <div class='section-title-wrap violet'>
        <h2 class='section-title medium'>Watch The Latest Match</h2>
        <div class='section-title-separator'></div>
      </div>
      {{#if this.videoUrl}}
        <div class='widget-media-wrap large'>
          <div class='widget-media-r'>
            <iframe src={{this.videoUrl}} allowfullscreen></iframe>
          </div>
        </div>
      {{else}}
        <div class='widget-media-wrap large'>
          <div class='widget-media-r no-video' style='display: flex; align-items: center; justify-content: center; height: 460px; background-color: #f5f5f5; border: 2px dashed #dbdbdb;'>
            <div class='no-video-content' style='text-align: center;'>
              <p style='color: #8b8b8b; margin-bottom: 16px;'>Video not available</p>
              {{#if @match}}
                <LinkTo @route='esports.matches.match' @model={{@match.slug}} class='button small violet'>
                  View Match Details
                </LinkTo>
              {{/if}}
            </div>
          </div>
        </div>
      {{/if}}
    </div>
  </template>
}
